import { ROUTES_INDICADORES_TIPO } from '../../../enums';

/** Resolve o tipo de indicador a partir da rota pública atual. */
export function getIndicadoresTipoRouteContext(pPathname = '') {
  const xRoute = pPathname.split('/').filter(Boolean)[1] || '';

  return {
    route: xRoute,
    tipo: ROUTES_INDICADORES_TIPO[xRoute] || null
  };
}

/** Localiza os metadados visuais de um tipo pelo identificador canônico. */
export function getIndicadoresTipoRouteById(pTipoId) {
  return Object.values(ROUTES_INDICADORES_TIPO).find(pTipo => pTipo.id === pTipoId) || null;
}
